export const normName = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");

export const tokens = (s) => new Set((s || "").toLowerCase().match(/[a-z0-9]{3,}/g) || []);

export const similarity = (a, b) => {
  const ta = tokens(a), tb = tokens(b);
  if (!ta.size || !tb.size) return 0;
  let inter = 0;
  ta.forEach((t) => { if (tb.has(t)) inter += 1; });
  return inter / new Set([...ta, ...tb]).size;
};

export const newItem = (x = {}) => ({
  _sel: true, name: x.name || "", supplier_code: x.supplier_code || "", barcode: x.barcode || "",
  quantity: x.quantity || 0, unit: x.unit || "pz", unit_price: x.unit_price || 0, discount: x.discount || 0,
  price: x.price || 0, category: x.category || "Altro", tax_rate: x.tax_rate || 0,
  trace_class: x.trace_class || "confezionato", trace_required: x.trace_required !== undefined ? x.trace_required : true,
  lots: (x.lotto || x.expiry) ? [newLot({ quantity: x.quantity || 0, lot_number: x.lotto || "", expiry_date: x.expiry || "" })] : [],
});

export const newLot = (x = {}) => ({
  quantity: x.quantity ?? 0, lot_number: x.lot_number || "", expiry_date: x.expiry_date || "", date_type: x.date_type || "",
  production_date: x.production_date || "", origin: x.origin || "", producer: x.producer || "", brand: x.brand || "", barcode: x.barcode || "",
  storage_conditions: x.storage_conditions || "", storage_temperature: x.storage_temperature || "", net_weight: x.net_weight || "",
  label_image_path: x.label_image_path || "", ocr_raw_text: x.ocr_raw_text || "", ai_confidence: x.ai_confidence ?? null,
  ai_data: x.ai_data || null, corrected: !!x.corrected, match_warning: !!x.match_warning, _confirmed: !!x._confirmed,
});

export const lotsSum = (it) => Math.round((it.lots || []).reduce((s, l) => s + (parseFloat(l.quantity) || 0), 0) * 1000) / 1000;

export const traceStatus = (it) => {
  if (!it.trace_required) return "non_richiesta";
  const lots = (it.lots || []).filter((l) => l._confirmed || l.lot_number || l.expiry_date);
  if (!lots.length) return "da_completare";
  const complete = lots.every((l) => l.lot_number && l.expiry_date);
  const sumOk = Math.abs(lotsSum(it) - (parseFloat(it.quantity) || 0)) < 0.001;
  return complete && sumOk ? "completa" : "parziale";
};

export const STATUS_LABEL = {
  non_richiesta: { label: "Non richiesta", cls: "bg-muted text-muted-foreground" },
  da_completare: { label: "Da completare", cls: "bg-amber-500/15 text-amber-700" },
  parziale: { label: "Parziale", cls: "bg-sky-500/15 text-sky-700" },
  completa: { label: "Completa", cls: "bg-[hsl(var(--success))]/15 text-[hsl(var(--success))]" },
};

export const mergeItems = (items) => {
  const map = new Map();
  const order = [];
  items.forEach((it) => {
    const q = parseFloat(it.quantity) || 0;
    const p = parseFloat(it.price) || 0;
    const unitP = q ? Math.round((p / q) * 100) / 100 : p;
    const key = `${normName(it.name)}|${(it.unit || "").toLowerCase()}|${unitP}`;
    if (map.has(key)) {
      const e = map.get(key);
      e.quantity = (parseFloat(e.quantity) || 0) + q;
      e.price = Math.round(((parseFloat(e.price) || 0) + p) * 100) / 100;
      e.lots = [...(e.lots || []), ...(it.lots || [])];
    } else {
      map.set(key, { ...it, quantity: q, price: Math.round(p * 100) / 100 });
      order.push(key);
    }
  });
  return order.map((k) => map.get(k));
};

export const compressImage = (file, maxSide = 1600, quality = 0.85) => new Promise((resolve) => {
  if (!file.type.startsWith("image/") || file.size < 700 * 1024) return resolve(file);
  const img = new Image();
  const url = URL.createObjectURL(file);
  img.onload = () => {
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    c.toBlob((b) => { URL.revokeObjectURL(url); resolve(b ? new File([b], file.name.replace(/\.\w+$/, ".jpg"), { type: "image/jpeg" }) : file); }, "image/jpeg", quality);
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
  img.src = url;
});
